<template>
  <div class="comp-list container">
    <img class="img" src="https://hrss-tes.oss-cn-beijing.aliyuncs.com/hrss/image/2021/04/1618643073661.png" alt="">
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style lang="less">
.comp-list {
  padding: 50px 0 20px 0;

  .img {
    display: block;
    width: 100%;
    height: auto;
  }
}
</style>
